import { useRef, useState } from "react"
import convertPrice from "./convert"
import copy from "copy-to-clipboard"
import { Col, Input, Row } from "reactstrap"
import CodeTextarea from "./CodeTextarea"

const PriceConverterForm = () => {
  const [numberOfLines, setNumberOfLines] = useState(1)

  // refs
  const valuesToConvertTextarea = useRef(null)
  const convertedValuesTextarea = useRef(null)
  const coefAInput = useRef(null)
  const coefBInput = useRef(null)

  // functions
  const convertValues = async () => {
    const res = await convertPrice(
      valuesToConvertTextarea.current.value,
      parseInt(coefAInput.current.value),
      parseInt(coefBInput.current.value)
    )
    convertedValuesTextarea.current.value = res
  }
  const clickCopyAllHandler = () => {
    copy(convertedValuesTextarea.current.value)
  }

  return (
    <>
      <div>
        <h3>Price Converter</h3>
        <p>
          Convert easily a list of prices (generally from Excel) into another list of prices in a
          different currency.
        </p>
      </div>
      <form id="frmConverter" name="frmConverter">
        <div className="d-flex gap-1">
          <div>
            <h4>Prices to convert</h4>
            <CodeTextarea
              identifier="txtValuesToConvert"
              onChange={convertValues}
              ref={valuesToConvertTextarea}
              numberOfLines={numberOfLines}
              setNumberOfLines={setNumberOfLines}
            />
            <Row>
              <Col md="6">
                <label htmlFor="txtCoefA">Coefficient A (Multiplier)</label>
                <br />
                <Input
                  type="number"
                  id="txtCoefA"
                  name="txtCoefA"
                  innerRef={coefAInput}
                  defaultValue={14}
                  onChange={convertValues}
                />
              </Col>
              <Col md="6">
                <label htmlFor="txtCoefB">Coefficient B (Addition)</label>
                <br />
                <Input
                  type="number"
                  id="txtCoefB"
                  name="txtCoefB"
                  innerRef={coefBInput}
                  defaultValue={0}
                  onChange={convertValues}
                />
              </Col>
            </Row>
          </div>
          <div>
            <h4>Converted prices</h4>
            <CodeTextarea
              identifier="txtConvertedValues"
              ref={convertedValuesTextarea}
              numberOfLines={numberOfLines}
              setNumberOfLines={setNumberOfLines}
              readOnly
            />
            <center>
              <button
                onClick={clickCopyAllHandler}
                type="button"
                className="btn btn-primary"
                id="btnCopyAll"
                name="btnCopyAll"
              >
                Copy all
              </button>
            </center>
          </div>
        </div>
      </form>
    </>
  )
}

export default PriceConverterForm
